import type { Direction } from "../direction";
import type { PointsToDirection } from "../interfaces";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class BigSquidTentacleCut extends PhysicalThing implements PointsToDirection {
	static key = "BigSquidTentacleCut";
	private direction: Direction | null = null;

	constructor(xy: XY) {
		super(xy, false);
	}

	getDirection(): Direction | null {
		return this.direction;
	}

	setDirection(direction: Direction): void {
		this.direction = direction;
	}

	override isVisible(): boolean {
		return true;
	}

	override getZOrder(): number {
		return ZOrder.MOB;
	}

	override isHideUnderneath(): boolean {
		return false;
	}

	serialize(): Record<string, unknown> {
		return {
			...super.serialize(),
			direction: this.direction,
		};
	}

	static deserialize(data: any): BigSquidTentacleCut {
		const c = new BigSquidTentacleCut(deserializeXY(data.xy));
		c.visualId = data.visualId;
		c.direction = data.direction ?? null;
		return c;
	}
}
